import React from 'react';
import PropTypes from 'prop-types';

import FieldLabel from '../FieldLabel';
import withValidation from '../withValidation';
import styles from './styles.scss';

const LabeledField = ({ children, label, invalid, error, ...props }) => {
  const renderChildren = () =>
    React.Children.map(children, (child) =>
      React.cloneElement(child, {
        invalid,
        ...props,
      }),
    );

  return (
    <div>
      <FieldLabel>{label}</FieldLabel>
      <div>{renderChildren()}</div>
      {invalid && <span className={styles.error}>{error}</span>}
    </div>
  );
};

LabeledField.propTypes = {
  allowBlank: PropTypes.bool,
  children: PropTypes.node,
  invalid: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  error: PropTypes.string,
  value: PropTypes.string,
};

export default withValidation(LabeledField);



// WEBPACK FOOTER //
// src/components/shared/LabeledField/index.jsx